import React from 'react';
import { Form, ButtonGroup, ToggleButton } from 'react-bootstrap';

const CertificationSection = ({ formData, onChange }) => {
  const certificationOptions = [
    { value: 'BLS', label: 'BLS' },
    { value: 'ACLS', label: 'ACLS' },
    { value: 'PALS', label: 'PALS' },
  ];

  const renderToggleButtonGroup = (
    name,
    groupLabel,
    options,
    selectedValues,
    infoText = '',
    inputType = 'checkbox',
    styleOverride = { minWidth: '140px' },
    variant = 'outline-secondary'
  ) => (
    <Form.Group controlId={name} className="mb-4">
      <Form.Label className="h6" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
        {groupLabel} <span className="text-danger">*</span>
      </Form.Label>
      <ButtonGroup className="d-flex flex-wrap">
        {options.map((option, idx) => {
          const uniqueId = `${name}_${option.value}_${idx}`;
          const checked =
            inputType === 'radio'
              ? selectedValues === option.value
              : (selectedValues || []).includes(option.value);
          return (
            <ToggleButton
              key={uniqueId}
              id={uniqueId}
              type={inputType}
              variant={variant}
              name={name}
              value={option.value}
              checked={checked}
              onChange={onChange}
              className="m-1"
              style={styleOverride}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </ButtonGroup>
      {infoText && <Form.Text className="text-muted">{infoText}</Form.Text>}
    </Form.Group>
  );

  return (
    <>
      {renderToggleButtonGroup(
        'activeCertifications',
        'Active Certifications',
        certificationOptions,
        formData.activeCertifications || [],
        ''
      )}

      <Form.Group controlId="formActiveCertificationStatus" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
          Is your CRNA certification active? <span className="text-danger">*</span>
        </Form.Label>
        {['Yes', 'No', 'SRNA'].map((option, idx) => {
          const uniqueId = `activeCertStatus_${option}_${idx}`;
          return (
            <Form.Check
              key={uniqueId}
              id={uniqueId}
              label={option}
              name="crnaCertificationStatus"
              type="radio"
              value={option}
              checked={formData.crnaCertificationStatus === option}
              onChange={onChange}
              className="mb-2"
            />
          );
        })}
      </Form.Group>

      {/* {formData.crnaCertificationStatus === 'NBCRNA' && (
        <Form.Group controlId="formNBCRNAID" className="mb-4">
          <Form.Label className="h6" style={{ fontWeight: 'bold' }}>
            NBCRNA ID Number
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your NBCRNA ID Number (e.g., 104747)"
            name="credentials.nbcrnaId"
            value={formData.credentials.nbcrnaId || ''}
            onChange={onChange}
          />
        </Form.Group>
      )} */}

      <Form.Group controlId="formStateRNLicenses" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold' }}>
          State RN Licenses (comma-separated) <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          placeholder="e.g., PA, NJ, NY"
          name="stateLicensesInput"
          value={formData.stateLicensesInput}
          onChange={onChange}
          required
        />
      </Form.Group>

      <Form.Group controlId="formStateAPRNLicenses" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold' }}>
          State APRN Licenses (comma-separated)
        </Form.Label>
        <Form.Control
          type="text"
          placeholder="e.g., CA, TX"
          name="stateAPRNLicensesInput"
          value={formData.stateAPRNLicensesInput}
          onChange={onChange}
        />
      </Form.Group>
    </>
  );
};

export default CertificationSection;
